/**
 * Nút chọn giao diện: Theo hệ thống / Sáng / Tối.
 * Đặt ở footer SideBarContent nên tự có mặt cả ở sidebar desktop lẫn Drawer mobile.
 */

import React from "react";
import { Segmented, Tooltip } from "antd";
import { DesktopOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";

import { THEME_LABELS, type ThemeMode } from "./theme-storage";
import { useThemeMode } from "./theme-provider";

const OPTIONS = [
  { value: "system" as const, icon: <DesktopOutlined /> },
  { value: "light" as const, icon: <SunOutlined /> },
  { value: "dark" as const, icon: <MoonOutlined /> },
];

export default function ThemeToggle({ block = true }: { block?: boolean }) {
  const { mode, setMode } = useThemeMode();

  return (
    <Segmented
      block={block}
      value={mode}
      onChange={(value) => setMode(value as ThemeMode)}
      aria-label="Chế độ giao diện"
      options={OPTIONS.map((option) => ({
        value: option.value,
        label: (
          <Tooltip title={THEME_LABELS[option.value]}>
            <span aria-label={THEME_LABELS[option.value]}>{option.icon}</span>
          </Tooltip>
        ),
      }))}
    />
  );
}
